import React, { useState } from 'react';
import projectData from '../assets/projectsData.js';

const Projects = () => {
  const [projectsToShow, setProjectsToShow] = useState(6);

  const showMoreProjects = () => {
    setProjectsToShow(prev => prev + 6);
  };

  return (
    <div id="projects" className="bg-dark-blue flex flex-col items-center py-10 lg:py-20">
      <h2 className="text-xl lg:text-2xl font-bold mb-8">Projects</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-screen-xl px-4">
        {projectData.slice(0, projectsToShow).map((project) => (
          <div
            key={project.title}
            className="bg-dark-gray rounded-xl shadow-lg overflow-hidden flex flex-col hover:scale-[1.02] transition-transform duration-300 ease-in-out"
          >
            {project.image && (
              <a
                href={project.live || project.code}
                target="_blank"
                rel="noopener noreferrer"
                tabIndex={project.live || project.code ? 0 : -1}
              >
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-44 object-cover object-top"
                />
              </a>
            )}
            <div className="p-5 flex flex-col flex-1 text-left">
              <div className="flex justify-between items-baseline mb-2">
                <h3 className="text-lg font-semibold">{project.title}</h3>
                <span className="text-gold text-sm whitespace-nowrap ml-3">{project.year}</span>
              </div>
              <p className="text-sm text-gray-300 mb-4 flex-1">{project.description}</p>
              <div className="flex gap-5 mt-auto">
                {project.live && (
                  <a
                    href={project.live}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-400 hover:underline text-sm font-semibold"
                  >
                    Visit site ↗
                  </a>
                )}
                {project.code && (
                  <a
                    href={project.code}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-white hover:underline text-sm"
                  >
                    Source code
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      {projectsToShow < projectData.length ? (
        <button onClick={showMoreProjects} className="mt-8 p-2 px-6 bg-blue-500 text-white rounded">
          Show More
        </button>
      ) : (
        <p className="mt-8 text-white">More projects on the way!</p>
      )}
    </div>
  );
};

export default Projects;
